import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AUTH_ENDPOINTS } from './utils/auth'; // adjust path to match your project
import About from './components/About';
import AccountVerificationRequest from './components/AccountVerificationRequest';
import Blog from "./components/Blog";
import Career from './components/Career';
// import Course from "./components/Course";
import CourseCatalog from './components/Course/CourseCatalog';
import Dashboard from './components/Dashboard';
import GetTheApp from './components/GetTheApp';
import Home from './components/Home';
import HelpSupport from './components/HelpSupport';
import Terms from './components/Terms';
import SignIn from "./components/auth/SignIn"
import SignUp from "./components/auth/SignUp";
import Sitemap from './components/Sitemap';
import "./App.css"
import TrustSafety from './components/TrustSafety';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieSettings from './components/CookieSettings';
import Affiliate from './components/Affiliate';
// import Contact from './components/Contact'; // Your Contact component

// A simple component to protect routes
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('token');
//   return token ? children : <Navigate to="/auth/signIn" replace />;
// };


const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState('checking'); // "checking" | "authed" | "unauthed"

  // console.log()
  useEffect(() => {
    fetch(AUTH_ENDPOINTS.me, { credentials: 'include' })
      .then((res) => setStatus(res.ok ? 'authed' : 'unauthed'))
      .catch(() => setStatus('unauthed'));
  }, []);

  if (status === 'checking') {
    return <div>Loading...</div>; // swap for a spinner component if you have one
  }

  return status === 'authed' ? children : <Navigate to="/auth/signIn" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/auth/signin" element={<SignIn />} />
        <Route path="/auth/signup" element={<SignUp />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/AccountVerificationRequest" element={<AccountVerificationRequest />} />
        <Route path="/Blog" element={<Blog />}></Route>
        {/* <Route path="/courses" element={<CourseCatalog />}></Route> */}

        {/* To "View All" courses */}
        <Route path="/catalog" element={<CourseCatalog />} />

        {/* This covers the filtered pages. ':categorySlug' is the variable name */}
        <Route path="/catalog/:categorySlug" element={<CourseCatalog />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
      
        <Route path="/career" element={<Career />}></Route>
        <Route path="/help-support" element={<HelpSupport />}></Route>
        <Route path="/terms" element={<Terms />}></Route>
        <Route path="/sitemap" element={<Sitemap />}></Route>
        <Route path="/get-the-app" element={<GetTheApp />}></Route>
        <Route path="/trust-safety" element={<TrustSafety />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
        <Route path="/cookies-settings" element={<CookieSettings />}></Route>
        <Route path="/affiliate" element={<Affiliate />}></Route>
      </Routes>
    </BrowserRouter>
  );
}
//                             <BookOpenIcon color={PRIMARY_BLUE} />

export default App;


// import Header from "./components/Header";
// import "./App.css"

// function App() {
//   return (
//     <div className="App">
//       <Header />

//       <h2>Hi there, Welcome to the Youdemi App's frontend</h2>
//       <br />
//       <br />
//       <p>Click to go to login page</p>
//       <a href="/src/auth/login" >Login</a>
//       {/* <link to="/src/auth/login.jsx" >Login</link> */}

//     </div>
//   );
// }

// export default App;